"use strict";

exports.__esModule = true;
exports.default = void 0;

var _nav = _interopRequireDefault(require("./nav"));

var _navItem = _interopRequireDefault(require("./nav-item"));

var _navText = _interopRequireDefault(require("./nav-text"));

var _navForm = _interopRequireDefault(require("./nav-form"));

var _navItemDropdown = _interopRequireDefault(require("./nav-item-dropdown"));

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BNav: _nav.default,
  BNavItem: _navItem.default,
  BNavText: _navText.default,
  BNavForm: _navForm.default,
  BNavItemDropdown: _navItemDropdown.default,
  BNavItemDd: _navItemDropdown.default,
  BNavDropdown: _navItemDropdown.default,
  BNavDd: _navItemDropdown.default
};
var plugins = {
  DropdownPlugin: _dropdown.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/nav/index.js
// module id = 142
// module chunks = 7